import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl3;
const service = 'tibber';

class TibberService extends ServiceBase {
    /**
     * Fetches Tibber prices from the start of a day up to the last published slot.
     * @param {string} type - 'quarter' or 'hour', empty falls back to quarter
     * @param {number} ems - start of the (UTC) day in epoch ms
     * @returns {Promise}
     */
    getPrices = (type, ems) => {
        if (type === '') type = 'quarter';

        const url = `${baseUrl}/${service}/prices?ems=${ems}&type=${type}`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };
}

const tibberService = new TibberService();
export default tibberService;
